import { Dispatch } from 'redux';
import { getErrorJson } from '@mm/utils';
import {
  openAddEmailModal,
  openPrettyErrorModal,
} from '../modules/modalsState/actions';
import commonHandler, { ResponseOrError } from './common-handler';
import { StoreState } from '../store-interfaces';
import { CreatePayload } from '../actions/FacebookSessionCRUDActions';

const EMPTY_EMAIL_ERROR_CODE = 2005;
export const INVALID_INVITE_ERROR_CODE = 1001;

export const facebookSessionCreateHandler =
  (dispatch: Dispatch<StoreState>) =>
  async ({
    error,
    payload,
  }: {
    error: ResponseOrError;
    payload: CreatePayload;
  }) => {
    const json = error instanceof Response && (await getErrorJson(error));
    const { error_code: code } = json || {};

    switch (code) {
      case EMPTY_EMAIL_ERROR_CODE:
        return dispatch(openAddEmailModal(payload));
      case INVALID_INVITE_ERROR_CODE:
        return dispatch(
          openPrettyErrorModal({
            errorMessage:
              'Your invite link is invalid. Please ask company owner to provide a new invite.',
            title: 'Invalid invite',
          }),
        );
      default:
        return commonHandler(dispatch)(error);
    }
  };
